module.exports = __webpack_public_path__ + "static/media/a37.447276d8.pdf";